import PendingActionPill from './PendingActionPill.component';

export default PendingActionPill;
